export default "__VITE_ASSET__D2_fB4Jh__"